import PropTypes from 'prop-types';
import React from 'react';
import { moveCaretAtEnd } from '../../helpers/inputs';
import SimpleCurrencyInput from '../../SimpleCurrencyInput';

const CustomAmountInput = ({
  onChange,
  onSubmit,
  disabled,
  value,
  readOnly,
  currency,
}) => (
  <form onSubmit={onSubmit}>
    <fieldset disabled={disabled}>
      <div className="c-label-new">Amount to be Refunded</div>
      <div className="c-input-group">
        <SimpleCurrencyInput
          wrapperClassName="u-flex-1"
          precision={2}
          className="c-input c-input--prepend c-input-group__first"
          onInputChange={onChange}
          type="tel"
          onInputFocus={moveCaretAtEnd}
          value={value}
          readOnly={readOnly}
          currency={currency}
          autoFocus
          addPrefix
          dataAutomationId="input:refundCustomAmount"
        />
        <button
          disabled={disabled}
          className="c-btn c-btn--medium"
          data-automation-id="button:refundCustomAmount"
        >
          Refund
        </button>
      </div>
    </fieldset>
  </form>
);
CustomAmountInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  currency: PropTypes.string,
};
CustomAmountInput.defaultProps = {
  readOnly: false,
  disabled: false,
  currency: 'usd',
};

export default CustomAmountInput;
